/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TextBlockIcon = /*#__PURE__*/ createSvgIcon(
  'TextBlockIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M14.311 5.168h-8.62v2.725h1.316v-1.41h2.337v7.033H7.637v1.315h4.729v-1.315h-1.707V6.484h2.337v1.409h1.315V5.168z"
            fill="currentColor"
          />
          <rect
            x={1.5}
            y={1.5}
            width={17}
            height={17}
            rx={2}
            stroke="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TextBlockIcon;
